import React from 'react';

export function DownloadList(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.45368 8.21459L4.47291 6.28213C3.99853 5.81932 3.23879 5.8287 2.77598 6.30308C2.31318 6.77746 2.32255 7.5372 2.79693 8.00001L6.18093 11.3015C7.05081 12.1501 8.44404 12.1327 9.29244 11.2626L12.4941 7.97879C12.9568 7.50427 12.9472 6.74453 12.4726 6.28187C11.9981 5.81921 11.2384 5.82882 10.7757 6.30335L8.93492 8.19135L8.85368 8.19482V1.87383C8.85368 1.21109 8.31642 0.676071 7.65368 0.676071C6.99093 0.676071 6.45368 1.21333 6.45368 1.87607V8.21459ZM21.1857 11.4732C21.1857 10.8105 20.6485 10.2732 19.9857 10.2732H13.9857L13.863 10.2794C13.2579 10.3409 12.7857 10.8519 12.7857 11.4732C12.7857 12.136 13.323 12.6732 13.9857 12.6732H19.9857L20.1084 12.667C20.7135 12.6056 21.1857 12.0946 21.1857 11.4732ZM20.2714 15.2732C20.9342 15.2732 21.4714 15.8105 21.4714 16.4732C21.4714 17.0946 20.9992 17.6056 20.3941 17.667L20.2714 17.6732H5.7C5.03726 17.6732 4.5 17.136 4.5 16.4732C4.5 15.8519 4.9722 15.3409 5.57731 15.2794L5.7 15.2732H20.2714ZM21.4714 21.4732C21.4714 20.8105 20.9342 20.2732 20.2714 20.2732H5.7L5.57731 20.2794C4.9722 20.3409 4.5 20.8519 4.5 21.4732C4.5 22.136 5.03726 22.6732 5.7 22.6732H20.2714L20.3941 22.667C20.9992 22.6056 21.4714 22.0946 21.4714 21.4732Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
